import apiClient from './apiClient';

export class SoldItemsService {

    async getSoldItems(id) {
        const response = await apiClient.getWithCache("api/soldItems/" + id);
        return response.data;
    }

    async getSoldItemsForSnapshot(snapshotId, search) {
        const response = await apiClient.getWithCache("api/soldItems/snapshot/" + snapshotId, {
            params: search
        });

        return response.data;
    }

    async deleteSoldItem(id) {
        const response = await apiClient.delete("api/soldItems/delete/" + id);
        apiClient.clearCache('api/soldItems');
        return response.data;
    }
}
